import { render, staticRenderFns } from "./RiskProblemList.vue?vue&type=template&id=a1d0f032&scoped=true"
import script from "./RiskProblemList.vue?vue&type=script&lang=js"
export * from "./RiskProblemList.vue?vue&type=script&lang=js"
import style0 from "./RiskProblemList.vue?vue&type=style&index=0&id=a1d0f032&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d0f032",
  null
  
)

export default component.exports